/**
 * Series Navigator - Frontend Interactive Dots
 *
 * Initializes Tippy tooltips on series dots with post preview information.
 */

import tippy from 'tippy.js';

/**
 * Initialize series navigator interactive dots
 */
function initSeriesNavigator() {
	const navigators = document.querySelectorAll('.wp-block-series-navigator');

	navigators.forEach((navigator) => {
		const dots = navigator.querySelectorAll('.series-dot[data-series-post]');

		dots.forEach((dot) => {
			try {
				const postData = JSON.parse(dot.getAttribute('data-series-post'));

				// Create tooltip content
				const tooltipContent = `
					<div class="series-dot-tooltip">
						<h4 class="series-dot-tooltip__title">${escapeHtml(postData.title)}</h4>
						<p class="series-dot-tooltip__excerpt">${escapeHtml(postData.excerpt)}</p>
						<time class="series-dot-tooltip__date">${escapeHtml(postData.date)}</time>
					</div>
				`;

				// Initialize Tippy tooltip
				tippy(dot, {
					content: tooltipContent,
					allowHTML: true,
					theme: 'series-navigator',
					placement: 'top',
					arrow: true,
					interactive: false,
					appendTo: () => document.body,
					maxWidth: 300,
					animation: 'shift-away',
					duration: [200, 150],
					delay: [400, 0],
					hideOnClick: false,
				});

				// Add keyboard navigation support
				dot.addEventListener('keydown', (e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						window.location.href = postData.url;
					}
				});

			} catch (error) {
				console.error('Error initializing series dot:', error);
			}
		});
	});
}

/**
 * Simple HTML escape function
 */
function escapeHtml(text) {
	const div = document.createElement('div');
	div.textContent = text;
	return div.innerHTML;
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initSeriesNavigator);
} else {
	initSeriesNavigator();
}

// Re-initialize on dynamic content load (if needed)
document.addEventListener('series-navigator-reload', initSeriesNavigator);
